import React from "react";
import { SubmissionType } from "../../../generated/graphql";
import SelectionCardGroup, {
  SelectionCardOption,
} from "../../Inputs/SelectionCardGroup";
import { FlexRow } from "../__styles__/Layout";
import { Container, ContentSection, HeaderSection } from "../__styles__/Modal";
import { Title } from "../Typography";

type SubmissionTypeSelectionProps = {
  onSelect: (submissionTypeId: string) => void;
  submissionTypes: Array<
    Pick<SubmissionType, "id" | "name" | "category" | "description" | "modules">
  >;
};

export function SelectSubmissionType({
  onSelect,
  submissionTypes,
}: SubmissionTypeSelectionProps) {
  const submissionTypeOptions = submissionTypes.map(
    submissionType =>
      ({
        id: submissionType.id,
        value: submissionType.id,
        title: submissionType.name,
        iconName: "clipboard-check",
      }) satisfies SelectionCardOption,
  );

  return (
    <Container width="narrow">
      <HeaderSection>
        <FlexRow
          css={{ alignItems: "center", justifyContent: "space-between" }}
        >
          <Title size="small" type="semiBold">
            Send mail
          </Title>
        </FlexRow>
      </HeaderSection>
      <ContentSection>
        <SelectionCardGroup
          options={submissionTypeOptions}
          onChange={onSelect}
          orientation="vertical"
          spacingStyle="compact"
          borderStyle="ghost"
        />
      </ContentSection>
    </Container>
  );
}
